module.exports = __webpack_public_path__ + "static/xyj-92d186ba8811f686e32268d00df2480a.jpg";